import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";
import { CONTACT } from "@/config";

const sections = [
  {
    h: "1. Introduction",
    p: `This Privacy Policy explains how ${CONTACT.name}, an independent Car Sales Consultant at ${CONTACT.dealership}, collects, uses and protects the personal information you share through this website. This is a personal lead-generation website and is not an official Toyota dealership website. We are committed to protecting your privacy in line with the Protection of Personal Information Act (POPIA).`,
  },
  {
    h: "2. Information We Collect",
    p: "When you submit an inquiry or contact form, we may collect your name, phone number, email address, the vehicle you are interested in, and the contents of your message. We only collect the information you choose to provide.",
  },
  {
    h: "3. How We Use Your Information",
    p: "Your information is used solely to respond to your enquiry, provide vehicle information, arrange viewings or test drives, and follow up on your request. We do not sell or rent your personal information to third parties.",
  },
  {
    h: "4. Consent",
    p: "By submitting a form on this website, you consent to being contacted about your enquiry. You may withdraw your consent at any time by contacting us using the details below.",
  },
  {
    h: "5. Data Retention & Security",
    p: "We keep your information only as long as necessary to assist you, and we take reasonable measures to keep it safe and confidential.",
  },
  {
    h: "6. Your Rights",
    p: "You have the right to access, correct, or request deletion of your personal information. To exercise these rights, please contact us.",
  },
  {
    h: "7. Contact",
    p: `For any privacy questions or requests, contact ${CONTACT.name} at ${CONTACT.email} or ${CONTACT.phone}.`,
  },
];

const Privacy: React.FC = () => {
  return (
    <section className="container-x py-16">
      <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-50 text-blue-600">
        <ShieldCheck className="h-6 w-6" />
      </span>
      <h1 className="mt-5 text-4xl font-extrabold text-slate-900">Privacy Policy</h1>
      <p className="mt-3 text-sm text-slate-500">
        How your personal information is handled — POPIA compliant.
      </p>

      <div className="mt-8 space-y-7">
        {sections.map((s) => (
          <div key={s.h}>
            <h2 className="text-lg font-bold text-slate-900">{s.h}</h2>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.p}</p>
          </div>
        ))}
      </div>

      <Link to="/" className="btn-outline mt-10">
        <ArrowLeft className="h-4 w-4" /> Back to Home
      </Link>
    </section>
  );
};

export default Privacy;
